import { render, staticRenderFns } from "./media-list.vue?vue&type=template&id=044817b0"
import script from "./media-list.vue?vue&type=script&lang=js"
export * from "./media-list.vue?vue&type=script&lang=js"
import style0 from "./media-list.vue?vue&type=style&index=0&id=044817b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports